<template>
    <div class="full-content has-header">
        <div class="content-container">
            <div class="content-content">
                <ul class="lst-choix">
                    <b-row>
                        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                            <li>
                                <h2>Je me connecte en tant que : </h2>
                            </li>
                        </b-col>
                        <!-- <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                            <li>
                                <h4>Assignateur : </h4>
                            </li>
                        </b-col> -->
                        <template v-for="env in envs">
                            <b-col v-if="env.env_flag_t == 'assignateur' && env_assign.indexOf(env.env_id_n) > -1" xl="6"
                                lg="6" md="6" sm="6" xs="6" @click="goToAssign(env, 'env_assign')">
                                <li class="li-cat">
                                    <div class="vignette-categorie">
                                        <div class="col-image">
                                            <font-awesome-icon size="6x" icon="user"></font-awesome-icon>
                                        </div>

                                        <div class="col-txt big" v-if="userConnected.role == 0">Assignateur -
                                            {{ env.dos_lib_t }} / {{ env.env_nom_t }}</div>
                                        <div class="col-txt big" v-else>Assignateur</div>
                                    </div>
                                </li>
                            </b-col>
                        </template>
                        <!-- <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                            <li>
                                <h4>Modérateur : </h4>
                            </li>
                        </b-col> -->
                        <template v-for="env in envs">
                            <b-col v-if="env.env_flag_t == 'moderateur' && env_moder.indexOf(env.env_id_n) > -1" xl="6"
                                lg="6" md="6" sm="6" xs="6" @click="goToModer(env, 'env_moder')">
                                <li class="li-cat">
                                    <div class="vignette-categorie">
                                        <div class="col-image">
                                            <font-awesome-icon size="6x" icon="users"></font-awesome-icon>
                                        </div>

                                        <div class="col-txt big" v-if="userConnected.role == 0">Modérateur -
                                            {{ env.dos_lib_t }} / {{ env.env_nom_t }}</div>
                                        <div class="col-txt big" v-else>Modérateur</div>
                                    </div>
                                </li>
                            </b-col>
                        </template>
                    </b-row>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Vuex from "vuex";
import router from "../router/index.js";
import Vue from "vue";

export default {
    name: "Environnement",
    data() {
        return {
            env_moder: window.env_moder,
            env_assign: window.env_assign
        };
    },
    async mounted() {
        await this.getEnvironnements(this.userConnected);

        this.setNeedReturn(false);

        // if(JSON.parse(localStorage['env_assign']).ENV_ID_N == null)
        //     router.push({name: 'moder'});
        // console.log(JSON.parse(localStorage['env_moder']), this.userConnected, this);
        // if(JSON.parse(localStorage['env_moder']).env_id_n == null || (this.userConnected.userId != 2139 && this.userConnected.userId != 199))
        //     router.push({name: 'assign'});

    },
    methods: {
        ...Vuex.mapActions('Environnement', ['getEnvironnements', 'setEnvironnement']),
        ...Vuex.mapActions("Application", ['setNeedReturn']),
        goToAssign(env, type) {
            console.log(env, type);
            this.setEnvironnement({ env, type });
            router.push({ name: 'assign' });

        },
        goToModer(env, type) {
            console.log(env, type);
            this.setEnvironnement({ env, type });
            router.push({ name: 'moder' });

        }
    },
    computed: {
        ...Vuex.mapGetters('Environnement', ['envs', 'envAssign', 'envModer']),
        ...Vuex.mapGetters('Authentification', ['userConnected']),
        ...Vuex.mapGetters("Application", ['needReturn'])
    }
}
</script>

<style scoped></style>
